import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=7581a725&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports